import useAppointmentStore from '@/store/AppointmentStore';
import { getSearchedDestinationLabel } from '@/utils/formatSearchedDestination';

const useSearchedDestinationLabel = (): string =>
  useAppointmentStore((state) => {
    const resolvedLabel = getSearchedDestinationLabel(
      state.searchedDestination,
    );
    if (resolvedLabel) {
      return resolvedLabel;
    }

    return state.userSearch.trim();
  });

export default useSearchedDestinationLabel;
